import { createRoutine } from 'redux-saga-routines';

export const searchItemsRoutine = createRoutine('SEARCH_ITEMS');

export const fetchRecentRoutine = createRoutine('FETCH_RECENT_ITEMS');
